import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    signInCartContainer?: GridContainerProps;
    headerGridItemContainer?: GridItemProps;
    searchContainer: InjectableCss;
    mainNav: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: flex-start;
            max-width: 1700px;
            padding: 5px 10px;
            margin: 0 auto;
            flex-wrap: nowrap;
        `,
    },
    logoWrapper: {
        css: css`
            display: flex;
            flex: 0 0 0%;
            text-align: left;
            padding: 0 40px 0 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 42px;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            min-width: 320px;
            display: flex;
            align-items: center;
            flex: 0 1 20%;
            padding: 0 0 0 0;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    signInCartContainer: {
        css: css`
            & ${GridOffset} {
                width: 100%;
                margin: 0;
                justify-content: flex-end;
            }
        `,
    },
    headerGridItemContainer: {
        css: css`
            padding-top: 5px !important;
            padding-bottom: 5px !important;
            padding-left: 0;
            padding-right: 0;
            text-align: center;
        `,
    },
    searchContainer: {
        css: css`
            flex: 0 0 100%;
            width: 100%;
        `,
    },
    mainNav: {
        css: css`
            display: flex;
            flex: 0 2 43%;
            align-items: center;
            margin-left: auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            flex: 0 2 15%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <div>
        <StyledWrapper id="headercontainer" {...logoLinksSearchStyles.container}>
            <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
                <Zone contentId={id} zoneName="Logo" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.mainNav}>
                <Zone contentId={id} zoneName="MainNavigation" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
                <GridContainer {...logoLinksSearchStyles.signInCartContainer}>
                    <GridItem width={3} {...logoLinksSearchStyles.headerGridItemContainer}>
                        <Zone contentId={id} zoneName="Support" />
                    </GridItem>
                    <GridItem width={3} {...logoLinksSearchStyles.headerGridItemContainer}>
                        <Zone contentId={id} zoneName="Quick Order" />
                    </GridItem>
                    <GridItem width={3} {...logoLinksSearchStyles.headerGridItemContainer}>
                        <Zone contentId={id} zoneName="Cart" />
                    </GridItem>
                    <GridItem width={3} {...logoLinksSearchStyles.headerGridItemContainer}>
                        <Zone contentId={id} zoneName="SignIn" />
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.searchContainer}>
            <Zone contentId={id} zoneName="Search"></Zone>
        </StyledWrapper>
    </div>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
        fieldDefinitions: [],
    },
};

export default logoLinksSearch;
